var _path, _circle, _ellipse, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _path4, _circle3, _rect9, _g, _g2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _g3, _path5, _circle4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaseApplicationCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 314,
    viewBox: "0 0 454 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.613C-6.0574e-05 194.869 22.8556 259.961 72.2953 288.592C122.777 317.825 165.101 293.365 224.632 294.33C269.596 295.058 297.305 307.988 339.788 294.33C399.898 275.004 465.116 241.87 451.329 184.349C441.741 144.347 396.081 144.996 367.673 113.579C339.335 82.2384 342.374 49.8818 307.255 25.1166C231.235 -28.4914 138.522 11.6758 67.6478 71.0215C31.6352 101.176 6.05743e-05 140.357 0 167.613Z",
    fill: "#FFF2F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 238.212,
    cy: 77.9353,
    r: 50.9353,
    stroke: "#F39DB2",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.8922,
    cy: 82.2802,
    rx: 84.8922,
    ry: 82.2802,
    transform: "matrix(-1 0 0 1 210.784 106.668)",
    stroke: "#F29DB1",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.795,
    cy: 201.356,
    r: 34.6099,
    stroke: "#FFCAD7",
    strokeWidth: 1.30603,
    strokeLinecap: "round",
    strokeDasharray: "5.22 7.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 155.481,
    y: 82.7227,
    width: 27.2215,
    height: 5.40889,
    transform: "rotate(-45 155.481 82.7227)",
    fill: "#F39DB2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 159.094,
    y: 63,
    width: 28.1513,
    height: 5.78984,
    transform: "rotate(45 159.094 63)",
    fill: "#F39DB2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 337.241,
    y: 126.861,
    width: 13.6107,
    height: 2.70445,
    transform: "rotate(-45 337.241 126.861)",
    fill: "#FCBFCE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 339.047,
    y: 117,
    width: 14.0756,
    height: 2.89492,
    transform: "rotate(45 339.047 117)",
    fill: "#FCBFCE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 227.32,
    y: 282.148,
    width: 18.1477,
    height: 3.60593,
    transform: "rotate(-45 227.32 282.148)",
    fill: "#FDBFCE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 229.729,
    y: 269,
    width: 18.7675,
    height: 3.85989,
    transform: "rotate(45 229.729 269)",
    fill: "#FDBFCE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 405.32,
    y: 213.148,
    width: 18.1477,
    height: 3.60593,
    transform: "rotate(-45 405.32 213.148)",
    fill: "#F39DB2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 407.729,
    y: 200,
    width: 18.7675,
    height: 3.85989,
    transform: "rotate(45 407.729 200)",
    fill: "#F39DB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104 82C104 86.4183 100.418 90 96 90C94.4212 90 92.9493 89.5427 91.7094 88.7533L102.753 77.7094C103.543 78.9493 104 80.4212 104 82ZM89.3643 86.47L100.47 75.3643C99.1937 74.5029 97.6556 74 96 74C91.5817 74 88 77.5817 88 82C88 83.6556 88.5029 85.1937 89.3643 86.47ZM108 82C108 88.6274 102.627 94 96 94C89.3726 94 84 88.6274 84 82C84 75.3726 89.3726 70 96 70C102.627 70 108 75.3726 108 82Z",
    fill: "#FCBFCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339 261C339 265.971 334.971 270 330 270C328.197 270 326.518 269.47 325.11 268.557L337.557 256.11C338.47 257.518 339 259.197 339 261ZM322.571 266.082L335.082 253.571C333.636 252.58 331.886 252 330 252C325.029 252 321 256.029 321 261C321 262.886 321.58 264.636 322.571 266.082ZM343 261C343 268.18 337.18 274 330 274C322.82 274 317 268.18 317 261C317 253.82 322.82 248 330 248C337.18 248 343 253.82 343 261Z",
    fill: "#F39DB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310.342 59.2614C310.169 58.6257 310.648 58 311.307 58H321.693C322.352 58 322.831 58.6257 322.658 59.2614L317.465 78.4361C317.199 79.4209 315.801 79.4209 315.535 78.4361L310.342 59.2614Z",
    fill: "#F39DB2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.5,
    cy: 86.5,
    r: 3.5,
    fill: "#F39DB2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2226_9250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 152,
    width: 59,
    height: 59
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 164.424,
    width: 48,
    height: 48,
    transform: "rotate(-15 96 164.424)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2226_9250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.394 201.369C119.332 201.654 118.321 201.519 117.361 200.965C116.402 200.411 115.78 199.603 115.495 198.54L108.766 173.426L106.834 173.944L105.799 170.08L115.458 167.492L114.941 165.56L126.532 162.454L127.049 164.386L136.709 161.798L137.744 165.662L135.812 166.179L142.541 191.293C142.826 192.356 142.691 193.367 142.137 194.326C141.584 195.286 140.775 195.908 139.713 196.192L120.394 201.369ZM131.948 167.215L112.63 172.391L119.359 197.505L138.678 192.329L131.948 167.215ZM122.187 192.606L126.051 191.571L121.392 174.184L117.529 175.22L122.187 192.606ZM129.915 190.536L133.779 189.5L129.12 172.114L125.256 173.149L129.915 190.536Z",
    fill: "#FFBFCF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_2226_9250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126 82C126 79.7909 127.791 78 130 78H237.119C238.186 78 239.208 78.4259 239.959 79.1831L248.786 88.082L258.021 97.413C258.763 98.1619 259.179 99.1731 259.179 100.227V243.714C259.179 245.923 257.388 247.714 255.179 247.714H130C127.791 247.714 126 245.923 126 243.714V82Z",
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 187.286,
    y1: 168.582,
    x2: 235.286,
    y2: 168.582,
    stroke: "#FFCAD7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 187.286,
    y1: 158.582,
    x2: 235.286,
    y2: 158.582,
    stroke: "#FFCAD7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 188.286,
    y1: 177.582,
    x2: 214.286,
    y2: 177.582,
    stroke: "#FFCAD7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 152.286,
    y1: 104.582,
    x2: 185.702,
    y2: 104.582,
    stroke: "#EF476F",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 151.286,
    y1: 118.547,
    x2: 235.286,
    y2: 118.547,
    stroke: "#FFCAD7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 151.416,
    y1: 127.582,
    x2: 198.13,
    y2: 127.582,
    stroke: "#FFCAD7",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 197.286,
    y1: 227.582,
    x2: 236.286,
    y2: 227.582,
    stroke: "#EF476F",
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2226_9250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.786 98.082L258.786 99.082L237.786 78.082L238.786 98.082Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.334 187.257C150.165 186.622 150.644 186 151.3 186H165.7C166.356 186 166.835 186.622 166.666 187.257L159.466 214.361C159.203 215.353 157.797 215.353 157.534 214.361L150.334 187.257Z",
    fill: "#EF476F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.5,
    cy: 223.5,
    r: 4.5,
    fill: "#EF476F"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_2226_9250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.255,
    y: 235.299,
    width: 169.766,
    height: 33.7324,
    transform: "rotate(-45 171.255 235.299)",
    fill: "#EF476F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.787,
    y: 112.256,
    width: 175.565,
    height: 36.1081,
    transform: "rotate(45 193.787 112.256)",
    fill: "#EF476F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_2226_9250",
    x: 107,
    y: 75,
    width: 171.179,
    height: 238.715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2226_9250"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2226_9250",
    result: "effect2_dropShadow_2226_9250"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2226_9250",
    result: "effect3_dropShadow_2226_9250"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 47
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.8 0 0 0 0 0.843137 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2226_9250",
    result: "effect4_dropShadow_2226_9250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2226_9250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2226_9250",
    x: 234.786,
    y: 77.082,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.832587 0 0 0 0 0.851891 0 0 0 0 0.920833 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2226_9250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2226_9250",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2226_9250",
    x: 148.255,
    y: 112.256,
    width: 189.675,
    height: 189.676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2226_9250"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.278431 0 0 0 0 0.435294 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2226_9250",
    result: "effect2_dropShadow_2226_9250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2226_9250",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaseApplicationCancel);
export default __webpack_public_path__ + "static/media/lease-application-cancel.90883628a04df35873dea38fdace98e3.svg";
export { ForwardRef as ReactComponent };